import { Debounce } from '@/assets/js/common.js'
import { freetrialClick, freetrialView } from '@/utils/freetrialClick.js'

export default {
  name: '',
  data() {
    return {
      finished: false,
      loading: false,
      current: 1,
      detailParams: {
        pageNum: 1,
        pageSize: 5,
        haveData: false, // 是否还有数据
      },
      productsList: [],
      hasGetData: false, // 是否获取过数据
      havePreview: false, // 是否有上新预告的商品，默认false
    }
  },
  mounted() {
    this.crmId = JSON.parse(localStorage.getItem('userInfo')).crm_id
    this.hasGetData = false
    this.productsList = []
    this.detailParams.pageNum = 1
    this.$http.get(
      '/trial/goods/list',
      { type: this.current - 1 },
      (res) => {
        if (res.code === 200) {
          const { havePreview, data = [] } = res.data
          if (data.data.length === 0 && havePreview) {
            this.hasGetData = true
            this.changeTab(2)
          }
          this.havePreview = this.current === 1 ? havePreview : true
          this.productsList = [...data.data]
          this.detailParams.haveData = data.haveData
        }
        this.hasGetData = true
      },
      (err) => {
        console.log(err)
        this.hasGetData = true
      },
      'lucky'
    )
    // this.getGoodsList();
    freetrialView({ xmhh5_Freetrial_pageview: '首页-正在进行' })
  },
  methods: {
    onload() {
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    changeTab(type) {
      this.finished = true
      setTimeout(() => {
        this.loading = false

        this.finished = false
      }, 500)
      if (type == this.current) return
      // 接口返回数据之后才允许切换tab
      if (!this.hasGetData) return
      freetrialView({
        xmhh5_Freetrial_pageview: type == 1 ? '首页-正在进行' : '首页-上新预告',
      })
      this.current = type
      this.getGoodsList()
    },
    foramt(stringTime) {
      let timestamp2 = new Date(stringTime.replace(/-/g, '/'))
      return timestamp2 - new Date()
    },
    // 获取商品列表
    getGoodsList() {
      this.hasGetData = false
      this.productsList = []
      this.detailParams.pageNum = 1
      this.$http.get(
        '/trial/goods/list',
        { type: this.current - 1 },
        (res) => {
          if (res.code === 200) {
            const { havePreview, data = [] } = res.data
            this.havePreview = this.current === 1 ? havePreview : true
            this.productsList = [...data.data]
            this.detailParams.haveData = data.haveData
          }
          this.hasGetData = true
        },
        (err) => {
          console.log(err)
          this.hasGetData = true
        },
        'lucky'
      )
    },
    getMoreData: Debounce(function () {
      this.$http.post(
        '/trial/goods/listByPage',
        {},
        {
          type: this.current - 1,
          pageNum: this.detailParams.pageNum,
          pageSize: this.detailParams.pageSize,
        },
        (res) => {
          if (res.code === 200) {
            const { data, haveData } = res.data
            this.productsList = this.productsList.concat([...data])
            this.detailParams.haveData = haveData
            // 如果还有数据，则页数++
            if (haveData) {
              this.detailParams.pageNum++
            }
          } else {
            this.$toast({
              message: res.message,
              duration: 2000,
              forbidClick: true,
              context: this,
            })
            this.loginFlag = true
          }
        },
        (err) => {
          console.log(error)
        },
        'lucky'
      )
    }),
    // 点击免费申请
    allowApplyHandle: Debounce(function (data) {
      freetrialClick({
        xmhh5_Freetrial_pageclick: '试用申请-免费申请',
        xmhh5_Freetrial_productclick: data.goodsName,
      })
      // 调用接口，判断用户是否申请过该产品
      this.$http.post(
        '/trial/apply/judgeUserIsApply',
        {},
        {
          crmId: this.crmId,
          id: data.id,
        },
        (res) => {
          if (res.code === 200) {
            // data为true表示已经申请过,提示用户，否则跳转申请页面，将id带过去
            // if(res.data) {
            this.$router.push({
              path: '/trialApplication',
              query: {
                id: data.id,
                applyStatus: res.data,
              },
            })
            // }else {
            //   this.$router.push({ path: "/trialApplication", query: { id: id } });
            // }
          } else {
            this.$toast({
              message: res.message,
              duration: 2000,
              forbidClick: true,
              context: this,
            })
            this.loginFlag = true
          }
        },
        (err) => {
          console.log(err)
        },
        'lucky'
      )
    }),
  },
}
